/**
 * TabOwnershipBanner (M4).
 *
 * Rendered when this tab is in `readonly` mode because another tab
 * owns the same sessionUid. Occupies the full charging surface so
 * the user can't accidentally fire a stop / cancel that would race
 * the owning tab's controls.
 *
 * The "Use this tab" button hands ownership over via BroadcastChannel;
 * the owning tab's controller downgrades on receipt.
 */

import React from 'react';
import PropTypes from 'prop-types';
import './TabOwnershipBanner.less';

export default function TabOwnershipBanner({ onTakeover }) {
  return (
    <div className="gc-tabown" role="status" aria-live="polite">
      <div className="gc-tabown-icon" aria-hidden="true">🪟</div>
      <h1 className="gc-tabown-title">This charging session is open in another tab.</h1>
      <p className="gc-tabown-body">
        To keep the session safe we've paused controls in this tab. If
        the other tab is closed or on a different device, you can take
        over here.
      </p>
      {typeof onTakeover === 'function' && (
        <button type="button" className="gc-tabown-btn" onClick={onTakeover}>
          Use this tab
        </button>
      )}
    </div>
  );
}

TabOwnershipBanner.propTypes = {
  onTakeover: PropTypes.func,
};
